<template>
    <div id="post-list">
        <Header></Header>
        <loader @onLoadingComplete="onLoadingComplete"></loader>
        <post-list-page v-show="!loading"></post-list-page>
        <Footer></Footer>
    </div>
</template>

<script>
    import Header from '../components/common/Header'
    import Footer from '../components/common/Footer'
    import PostListPage from '../components/pages/PostListPage'
    import Loader from '../components/common/Loader'

    export default {
        name: 'PostList',
        props: ['type'],
        data() {
            return {
                loading: true,
            }
        },
        components: {
            Header,
            PostListPage,
            Footer,
            Loader
        },
        methods: {
            onLoadingComplete(stat) {
                this.loading = stat;
            }
        },
        created() {

            if(this.type == 'search') {

                this.$store.dispatch('search', {
                    q: this.$route.params.q,
                    page: this.$route.query.page
                });

            } else if(this.type == 'tag_search') {

                this.$store.dispatch('searchByTag', {
                    menu_path: this.$route.params.menu_path,
                    tag: this.$route.params.tag,
                    page: this.$route.query.page
                });

            } else {
                this.$store.dispatch('getPostList', {
                    menu_path: this.$route.params.menu_path,
                    page: this.$route.query.page,
                });
                this.$store.dispatch('getMostPopularPosts', this.$route.params.menu_path);
                this.$store.dispatch('getRecentPosts', this.$route.params.menu_path);
            }
        },
        mounted() {

        }
    }
</script>